export default __webpack_public_path__ + "static/media/refresh.5a8a5ff7.svg";